import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  List,
  ListItem,
  Typography,
} from '@mui/material';
import React from 'react';

const waiverPoints = [
  {
    id: 1,
    text: 'Saya telah membaca dan menyetujui segala informasi terkait acara, peraturan serta informasi lainnya yang berkaitan dengan Surabaya Orthopedic Half Marathon 2025.',
  },
  {
    id: 2,
    text: 'Saya menyatakan dalam keadaan sehat secara fisik untuk mengikuti lomba Surabaya Orthopedic Half Marathon 2025.',
  },
  {
    id: 3,
    text: 'Saya menyatakan, segala bentuk cedera, penyakit atau cacat fisik yang terjadi sebelum lomba berlangsung, dimana Saya mengakui cedera tersebut menjadi tanggung jawab Saya.',
  },
  {
    id: 4,
    text: 'Saya menyadari bahwa lomba lari Surabaya Orthopedic Half Marathon 2025 berpotensi secara fisik menyebabkan saya cedera atau meninggal dunia selama lomba berlangsung. Jika Saya mengetahui adanya gangguan medis yang dapat mengganggu Saya saat lomba, maka Saya akan mengundurkan diri untuk mencegah bahaya cedera atau kondisi medis lainnya.',
  },
  {
    id: 5,
    text: 'Saya menyatakan berpartisipasi pada lomba Surabaya Orthopedic Half Marathon 2025 dengan pertimbangan mampu secara medis dan sudah terlatih dengan baik. Sehingga Saya bertanggung jawab penuh atas cedera atau kecelakaan dalam bentuk apapun yang mungkin terjadi saat Saya bepergian menuju ketempat acara lomba, selama lomba, atau sepulang dari lomba.',
  },
  {
    id: 6,
    text: 'Saya menyatakan setuju untuk mendapatkan pertolongan medis diluar kemampuan dari tim medis lomba, dimana Penyelenggara lomba Surabaya Orthopedic Half Marathon 2025 dapat mengatur evakuasi darurat ataupun perawatan yang dianggap perlu dengan segala biaya menjadi tanggung jawab Saya.',
  },
  {
    id: 7,
    text: 'Saya menyatakan setuju dan bertanggung jawab atas asuransi kesehatan Saya sendiri selama acara.',
  },
  {
    id: 8,
    text: 'Saya atas nama Saya sendiri dan ahli waris menyatakan melepaskan penyelenggara lomba Surabaya Orthopedic Half Marathon  2025, sponsor, race management, dan semua orang yang berkaitan dengan lomba Surabaya Orthopedic Half Marathon 2025 dari tanggung jawab atas semua klaim, tindakan atau kerusakan baik fisik maupun nonfisik yang mungkin timbul dari partisipasi Saya selama lomba.',
  },
  {
    id: 9,
    text: 'Saya menyatakan setuju bahwa informasi dalam bentuk dokumen pribadi yang termasuk didalamnya  riwayat kesehatan yang dikumpulkan pihak penyelenggara sebagai bagian dari proses mengikuti lomba dan kebutuhan dalam keadaan darurat medis.',
  },
  {
    id: 10,
    text: 'Saya menyatakan setuju untuk memenuhi segala bentuk aturan dan arahan yang diberikan oleh penyelenggara Surabaya Orthopedic Half Marathon 2025.',
  },
  {
    id: 11,
    text: 'Saya menyatakan memahami bahwa penyelenggara dapat mengubah rute jika diperlukan tanpa pemberitahuan sebelumnya.',
  },
  {
    id: 12,
    text: 'Saya menyatakan setuju untuk membawa semua perlengkapan yang diwajibkan kepada Saya selama  lomba dan mematuhi aturan yang ada dilingkungan lomba diadakan.',
  },
];

const SHOMWaiverDialog = ({ onAgreed }) => {
  const [open, setOpen] = React.useState(false);
  const [scroll, setScroll] = React.useState('paper');

  const handleClickOpen = (scrollType) => () => {
    // setOpen(true);
    // setScroll(scrollType);
    const targetUrl = '';

    // Buka di tab baru
    if (targetUrl !== '')
      window.open(targetUrl, '_blank', 'noopener,noreferrer');

    // Opsional: Jalankan fungsi onAgreed jika diperlukan setelah user klik link
    if (onAgreed) {
      onAgreed();
    }
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleAgree = () => {
    setOpen(false);
    onAgreed();
  };

  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  return (
    <React.Fragment>
      <Button onClick={handleClickOpen('paper')}>{`Lihat ToC`}</Button>
      <Dialog
        open={open}
        onClose={handleClose}
        scroll={scroll}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogTitle id="scroll-dialog-title">Term and Condition</DialogTitle>
        <DialogContent dividers={scroll === 'paper'}>
          {/* <DialogContentText style={{ fontWeight: 700 }}>
            Saya menyatakan telah membaca dan menyetujui keseluruhan pernyataan
            dalam dokumen ini, maka secara sadar Saya bertanggung jawab atas
            segala resiko yang terjadi selama dan setelah perlombaan
            berlangsung.
          </DialogContentText>
          <DialogContentText>
            Sehubungan dengan kepesertaan Saya di SURABAYA ORTHOPEDIC HALF
            MARATHON 2025, Saya secara sadar menyetujui pelepasan tanggung jawab
            atas segala resiko yang terjadi.
          </DialogContentText>
          <DialogContentText
            id="scroll-dialog-description"
            ref={descriptionElementRef}
            tabIndex={-1}
          >
            <List>
              {waiverPoints.map((poin, index) => (
                <ListItem
                  key={index}
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'flex-start',
                  }}
                >
                  <Typography style={{ marginRight: 4 }}>{poin.id}.</Typography>
                  {poin.text}
                </ListItem>
              ))}
            </List>
          </DialogContentText> */}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Close</Button>
          <Button onClick={handleAgree}>Agree</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default SHOMWaiverDialog;
